import * as React from 'react';
import { Button } from '@aws-amplify/ui-react';
import { Modal, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useActiveGame from '../hooks/useActiveGame';

export default function ResumeModal({ show, onClose }) {
  const navigate = useNavigate();
  const { list, remove, hydrate } = useActiveGame();

  const handleResume = (id) => {
    const h = hydrate(id);
    if (!h) {
      onClose();
      return;
    }
    onClose();
    navigate(h.route, { state: h.state });
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Resume Game</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {(!list || list.length === 0) && (
          <Card className="p-3 text-center">
            <p className="mb-0">No active games to resume.</p>
          </Card>
        )}

        {list && list.length > 0 && (
          <div>
            {list.map(active => (
              <Card key={active.id} className="mb-3 p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <h5 style={{ marginBottom: 4 }}>{active.displayName || active.gameType}</h5>
                    <div style={{ fontSize: '0.9rem', color: '#6c757d' }}>{active.gameType || 'Game'}</div>
                  </div>
                  <div style={{ textAlign: 'right', fontSize: '0.85rem', color: '#6c757d' }}>{new Date(active.updatedAt).toLocaleString()}</div>
                </div>
                <div className="mb-2" style={{ marginTop: 8 }}>
                  <strong>Players:</strong>
                  <ul>
                    {(active.players || []).map((p, i) => {
                      const display = (p && (p.Name || p.name)) || String(p) || `Player ${i+1}`;
                      const key = (p && (p.id || p.Name || p.name)) || `p-${i}`;
                      return <li key={key}>{display}</li>;
                    })}
                  </ul>
                </div>
                <div className="d-flex gap-2">
                  <Button onClick={() => handleResume(active.id)} variation="primary">Resume</Button>
                  <Button onClick={() => { remove(active.id); }} variation="quiet">Delete</Button>
                </div>
              </Card>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variation="primary">Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
